module.exports = __webpack_public_path__ + "img/lock.c1efeaff.svg";